import { cx } from '@emotion/css';
import { useCallback } from 'react';

import withControl, { WithControlRenderProps } from '../withControl';

import {
  activeRadioClassName,
  inputClassName,
  labelClassName,
  radioClassName,
  radioOptionClassName,
  subtitleClassName,
  titleClassName,
} from './styles';
import { RadioOptionProps } from './types';

type Props = RadioOptionProps & WithControlRenderProps;

const RadioOption = ({
  onChange,
  value,
  title,
  subtitle,
  option,
  ref,
}: Props) => {
  const isActive = value === option;

  const onClick = useCallback(() => {
    onChange(option);
  }, [option, onChange]);

  return (
    <label className={radioOptionClassName} ref={ref}>
      <div className={labelClassName}>
        <h2 className={titleClassName}>{title}</h2>
        {subtitle && <h4 className={subtitleClassName}>{subtitle}</h4>}
      </div>
      <div className={radioClassName}>
        <input
          className={cx(inputClassName, { [activeRadioClassName]: isActive })}
          onClick={onClick}
          type="radio"
          value={value}
        />
      </div>
    </label>
  );
};

RadioOption.displayName = 'RadioOption';

export default withControl(RadioOption);
